// extracted by mini-css-extract-plugin
export default {"progress_bar":"small-diagram_progress_bar__rxbO8"};